import { useState } from "react";
import tabletrans from "../../translate/tables";
import StoryTableRow from "./StoryTableRow";

function StoryTable(props) {
  const content = props.content;
  const lang = props.lang;
  const [detail, showDetail] = useState(-1);
  return (
    <table>
      <thead>
        <tr>
          <th>
            <p>عنوان</p>
            <i></i>
          </th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        {content && content
          ? content.map((slider, i) => (
              <StoryTableRow
                detail={detail}
                showDetail={showDetail}
                item={slider}
                index={i}
                key={i}
                lang={lang}
              />
            ))
          : ""}
      </tbody>
    </table>
  );
}
export default StoryTable;
